import { ApiClient } from './ApiClient';
import { CustomerDTO } from '../domain/models';

export class CustomerApiService {
  constructor(private readonly http: ApiClient) {}

  list(): Promise<CustomerDTO[]> {
    // Pfad ohne führendes /api, da Base-URL bereits /api enthält
    return this.http.get('/customer/all');
  }

  create(customer: CustomerDTO): Promise<CustomerDTO> {
    return this.http.post('/customer', customer);
  }

  update(customer: CustomerDTO): Promise<CustomerDTO> {
    if (!customer.id) throw new Error('id erforderlich');
    return this.http.put(`/customer/${customer.id}`, customer);
  }

  remove(id: number): Promise<void> {
    return this.http.delete(`/customer/${id}`);
  }
}
